import { keepPreviousData } from '@tanstack/react-query';
import {
    PortfolioEnterpriseRelationshipResult,
    PortfolioStringFilterType,
    useRepositoryInfiniteQuery,
} from '@mews-commander/data-access';
import { TableState } from '@optimus-web/core';

const PAGE_SIZE = 50;

export const useEnterpriseSearchQuery = (tableState: TableState<PortfolioEnterpriseRelationshipResult>) =>
    useRepositoryInfiniteQuery(
        'portfolioEnterpriseRelationships',
        'getAll',
        ({ pageParam: pageIndex }) => ({
            pagination: {
                pageIndex,
                pageSize: PAGE_SIZE,
            },
            ...(tableState.globalFilters.search
                ? {
                      filters: {
                          name: [
                              {
                                  filterType: PortfolioStringFilterType.Contains,
                                  value: tableState.globalFilters.search,
                              },
                          ],
                      },
                  }
                : {}),
        }),
        {
            placeholderData: keepPreviousData,
            initialPageParam: 0,
            getNextPageParam: (lastPage, allPages) =>
                lastPage.totalRowCount < PAGE_SIZE * allPages.length ? undefined : allPages.length,
        }
    );
